var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PasswordResetSteps',{attrs:{"steps":_vm.steps,"image":"img/windows-pwb-graphic.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }